import React from 'react';
import { Box, Flex, Image, Heading, Text, Button, VStack, HStack, SimpleGrid, Link, Icon } from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa';

const stats = [
  { value: '200+', label: 'Employee' },
  { value: '400+', label: 'Clients' },
  { value: '2489', label: 'Certification' },
  { value: '500+', label: 'Internships' },
  { value: '1000+', label: 'Applied' },
];

const JobSecureSection = () => {
  return (
    <Box maxW="7xl" mx="auto" mt={{ base: 6, md: 12 }} mb={{ base: 4, md: 8 }} px={{ base: 2, md: 0 }}>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        bg="white"
        borderRadius="2xl"
        overflow="hidden"
        boxShadow="sm"
        align="stretch"
      >
        {/* Left: Image */}
        <Box flex="1" minH={{ base: '160px', sm: '220px', md: '340px' }}>
          <Image
            src="/jpg/join-us.jpeg"
            alt="Team"
            objectFit="cover"
            w="100%"
            h="100%"
          />
        </Box>
        {/* Right: Text */}
        <Box flex="1" bg="#235B5E" color="white" p={{ base: 4, sm: 6, md: 10 }} display="flex" alignItems="center">
          <VStack align="start" spacing={{ base: 4, md: 6 }} w="full">
            <Heading fontSize={{ base: 'lg', sm: 'xl', md: '2.5rem' }} color="#E6FF3F" fontWeight="bold" lineHeight="1.1">
              Secure the job you’ve<br />always wanted
            </Heading>
            <Text color="white" fontSize={{ base: 'sm', sm: 'md', md: 'lg' }} maxW="lg">
              Commonly used in the graphic, print publishing industris for previewing visual mockups. limited social discrimination.
            </Text>
            <Button
              variant="outline"
              color="white"
              borderColor="white"
              borderRadius="full"
              px={{ base: 4, md: 8 }}
              py={{ base: 2, md: 6 }}
              fontWeight="bold"
              fontSize={{ base: 'sm', md: 'lg' }}
              rightIcon={<FaArrowRight />}
              _hover={{ bg: 'white', color: '#235B5E', borderColor: 'white' }}
              onClick={() => { window.location.href = '/job-opening'; }}
            >
              Find your job. <Text as={Link} color="white" textDecor="underline" ml={1} _hover={{ color: '#235B5E' }}>Explore all</Text>
            </Button>
          </VStack>
        </Box>
      </Flex>
      {/* Stats */}
      {/* <SimpleGrid columns={{ base: 2, sm: 3, md: 5 }} spacing={0} mt={{ base: 5, md: 10 }} bg="white" borderRadius="xl" px={{ base: 0, md: 2 }}>
        {stats.map((stat, idx) => (
          <VStack key={stat.label} py={{ base: 3, md: 6 }} spacing={1} borderRight={idx !== stats.length - 1 ? '1px solid #E5E7EB' : 'none'}>
            <Text fontSize={{ base: 'lg', md: '2.2rem' }} fontWeight="bold" color="#222">
              {stat.value}
            </Text>
            <Text color="gray.500" fontSize={{ base: 'xs', md: 'md' }}>{stat.label}</Text>
          </VStack>
        ))}
      </SimpleGrid> */}
      {/* <Box w="100%" h="0.5px" bg="#235B5E" my={8} /> */}
    </Box>
  );
};

export default JobSecureSection; 